import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { applyRuleFulfillment, cancelRuleFulfillment, changeFeature } from '../../model/configuratorSlice';
import RulesFeature from './Component/RulesFeature';
import { MinusRules, PlusRules } from '../../shared/svg/components';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const RulesPopup = () => {
  const mainCategoryAddedFromRule = useSelector(state => state.configurator.mainCategoryAddedFromRule);
  const mainCategoryRemovedFromRule = useSelector(state => state.configurator.mainCategoryRemovedFromRule);
  const addedCategoriesFromRule = useSelector(state => state.configurator.addedCategoriesFromRule);
  const removedCategoriesFromRule = useSelector(state => state.configurator.removedCategoriesFromRule);
  const dispatch = useDispatch();

  const onCancelClicked = () => {
    dispatch(cancelRuleFulfillment());
  };
  const onApplyClicked = () => {
    dispatch(applyRuleFulfillment());
    dispatch(changeFeature({
      room: null,
      feature: mainCategoryAddedFromRule.selected_feature,
      category: mainCategoryAddedFromRule.id,
      skipValidation: true,
    }));
    dispatch(cancelRuleFulfillment());
  };

  const showRuleNotFulfilled = true;

  return (
    <div className={`rules-popup ${showRuleNotFulfilled ? ' opened' : ''}`}>
      <div className={`background${showRuleNotFulfilled ? ' opened' : ''}`} />
      <div className={`panel${showRuleNotFulfilled ? ' opened' : ''}`}>
        <div className="header">
          {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-title', 'Asistente de configuración')}
        </div>
        <div className="sub-header">
          {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-subtitle',
              'Has seleccionado una opción que requiere una optimización.')}
        </div>
        <div className="mask-affected-categories">
          <div className="container-affected-categories">
            <div className="added-categories">
              <div className="title-container">
                <PlusRules />
                <div className="title">
                  {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-adding-text', 'Se añade:')}
                </div>
              </div>
              <div className="container-categories">
                <RulesFeature
                  categoryName={TranslationUtility.GetFormattedMessageForCategoryName(mainCategoryAddedFromRule)}
                  feature={mainCategoryAddedFromRule.features.find(
                          feature => feature.id === mainCategoryAddedFromRule.selected_feature,
                      )}
                />
                {addedCategoriesFromRule.map(category => (
                  <RulesFeature
                    categoryName={TranslationUtility.GetFormattedMessageForCategoryName(category)}
                    feature={category.features.find(
                              feature => feature.id === category.selected_feature,
                          )}
                  />
                  ))}
              </div>
            </div>
            <div className="removed-categories">
              <div className="title-container">
                <MinusRules />
                <div className="title">
                  {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-removing-text', 'Se suprime:')}
                </div>
              </div>
              <div className="container-categories">
                <RulesFeature
                  categoryName={TranslationUtility.GetFormattedMessageForCategoryName(mainCategoryRemovedFromRule)}
                  feature={mainCategoryRemovedFromRule.features.find(
                          feature => feature.id === mainCategoryRemovedFromRule.selected_feature,
                      )}
                />
                {removedCategoriesFromRule.map(category => (
                  <RulesFeature
                    categoryName={TranslationUtility.GetFormattedMessageForCategoryName(category)}
                    feature={category.features.find(
                              feature => feature.id === category.selected_feature,
                          )}
                  />
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container-buttons">
          <button type="button" onClick={onCancelClicked} className="cancel-button">
            <span>
              {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-title-button-cancel', 'Cancelar')}
            </span>
          </button>
          <button type="button" onClick={onApplyClicked} className="accept-button">
            <span>
              {TranslationUtility.GetFormattedMessageForUI('ui-rules-panel-button-accept', 'Aceptar')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesPopup;
